import React from 'react'

export const USDCIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 600.000000 600.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,600.000000) scale(0.100000,-0.100000)" fill="#2975C9" stroke="none">
        <path
          d="M2835 5994 c-637 -41 -1230 -271 -1725 -668 -106 -85 -308 -284 -402
-396 -344 -409 -573 -904 -662 -1430 -59 -353 -54 -735 14 -1081 148 -744 582
-1417 1200 -1859 364 -260 797 -439 1240 -514 353 -59 735 -54 1081 14 744
148 1417 582 1859 1200 260 364 439 797 514 1240 59 353 54 735 -14 1081 -148
744 -582 1417 -1200 1859 -415 296 -904 482 -1424 539 -102 12 -393 20 -481
15z m-434 -887 c32 -24 39 -56 39 -174 0 -147 -12 -172 -98 -210 -303 -133
-452 -228 -640 -407 -316 -302 -510 -698 -563 -1150 -15 -124 -7 -388 15 -511
70 -394 259 -750 542 -1026 170 -165 350 -287 544 -369 196 -83 200 -88 200
-263 0 -133 -9 -159 -64 -177 -29 -9 -46 -6 -132 25 -139 50 -360 160 -484
242 -346 229 -615 536 -795 908 -148 306 -219 622 -219 975 0 366 70 668 231
992 229 463 598 826 1061 1046 200 94 325 129 363 99z m1377 -23 c374 -140
704 -373 959 -677 496 -595 651 -1419 403 -2151 -165 -486 -471 -884 -900
-1169 -124 -82 -367 -203 -499 -247 -81 -28 -97 -30 -122 -19 -53 21 -59 41
-59 180 0 171 2 174 175 248 335 144 620 381 822 681 276 412 376 934 273
1429 -74 355 -272 710 -536 962 -183 174 -334 270 -636 402 -86 38 -98 63 -98
210 0 198 32 220 218 151z m-621 -638 l28 -24 5 -172 5 -173 69 -18 c232 -60
398 -215 465 -433 27 -89 27 -102 -8 -137 l-29 -29 -132 0 c-157 0 -170 6
-200 89 -61 165 -173 231 -395 232 -180 1 -292 -49 -347 -155 -33 -61 -32
-203 0 -264 48 -91 155 -135 442 -183 205 -34 307 -59 408 -101 145 -60 236
-138 293 -250 42 -84 59 -166 59 -299 0 -195 -54 -325 -190 -460 -61 -61 -97
-86 -178 -127 -60 -30 -134 -58 -182 -69 l-80 -18 0 -162 c0 -159 0 -162 -26
-192 l-26 -31 -135 0 -135 0 -29 29 -29 29 0 166 0 166 -23 0 c-51 0 -187 43
-277 87 -134 67 -230 163 -293 294 -54 113 -80 217 -65 260 17 49 51 59 197
59 129 0 131 0 160 -27 20 -19 36 -51 50 -99 54 -185 170 -263 407 -272 181
-7 282 23 371 110 61 60 86 125 86 223 0 201 -97 269 -470 330 -213 35 -330
67 -440 120 -107 52 -204 136 -246 214 -63 114 -86 320 -51 454 33 130 118
254 228 332 98 70 179 103 339 139 l27 6 0 161 0 161 29 29 29 29 131 0 c123
0 131 -1 158 -24z"
        />
      </g>
    </svg>
  )
}
